// removed by extract-text-webpack-plugin
module.exports = {"Page":"_16iYTd8VD3FuBEOlDyCt9a","skipContent":"_87kKPTunJ83iuXrjYtWGE","main":"_22zxYYzJpCFa0XgCBnG3pJ","Guide":"_1xg8aUKZ08NnabKYtcObfG","popupAware":"_37xx2nMGh1_2gCe9gbYZ1y"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/Page.css
// module id = 251
// module chunks = 8